export default function canOpenDocument(
  loadState: number[] = [],
  parseState: number[] = [],
  canOpenWhileProcessingIssues = false,
  canChatImmediately = false,
  needsToSeeDocumentText = false,
) {
  return (
    loadState.every(
      // TODO: handle item = 2?
      item => item === 3 || (item === 9 && canOpenWhileProcessingIssues),
    ) ||
    (canChatImmediately &&
      (needsToSeeDocumentText
        ? loadState.every(item => item === 1 || item === 9)
        : parseState.every(item => item >= 400)))
  );
}
